module.exports = __webpack_public_path__ + "img/bleu-5.b777eda8.png";